import type { WorkspaceDataStore } from './types';

export const workspaceStore = defineStore('workspaceStore', {
  state: (): WorkspaceStore.WorkspaceState => {
    return {
      workspaces: [],
      isLoading: true,
    };
  },
  actions: {
    WORKSPACE_RESET() {
      this.workspaces = [];
    },

    SET_LOADING_WORKSPACES(loading: boolean) {
      this.isLoading = loading;
    },

    SET_WORKSPACES(workspaces: WorkspaceDataStore[]) {
      this.workspaces = workspaces;
    },

    ADD_WORKSPACE(workspace: WorkspaceDataStore) {
      this.workspaces.push(workspace);
    },

    UPDATE_WORKSPACE(workspace: WorkspaceDataStore) {
      const index = this.workspaces.findIndex((w) => w.id === workspace.id);

      if (index > -1) {
        this.workspaces.splice(index, 1, workspace);
      }
    },
  },
});

namespace WorkspaceStore {
  export type WorkspaceState = {
    workspaces: WorkspaceDataStore[];
    isLoading: boolean;
  };
}
